import { render } from "./JzShowModel.vue?vue&type=template&id=4a85cade&scoped=true"
import script from "./JzShowModel.vue?vue&type=script&lang=js"
export * from "./JzShowModel.vue?vue&type=script&lang=js"

import "./JzShowModel.vue?vue&type=style&index=0&id=4a85cade&scoped=true&lang=scss"

import exportComponent from "D:\\project\\pc\\website\\node_modules\\_vue-loader@16.8.3@vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a85cade"]])

export default __exports__